import { Box, Button, Typography } from "@mui/material";
import { FC } from "react";
import { Colors } from "../../../styles/constant";
import {
  timeDifferenceInDays,
  timeDifferenceInHrs,
} from "../../../utils/helper";
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import { NotificationsData } from "../GeneralAppElements_Types";
import clevertap from "../../../utils/CleverTap";

interface CommonProps {
  title: string;
  notificationListData: NotificationsData[];
  handleNotificationDrawer: any;
  handleNotificationDataChange: Function;
  handleUnreadBtnClick: Function;
}
const CommonSearchableScreen: FC<CommonProps> = ({
  title,
  notificationListData,
  handleNotificationDrawer,
  handleNotificationDataChange,
  handleUnreadBtnClick,
}) => {
  return (
    <Box className="notifications">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="h5"
          fontWeight={500}
          color={Colors.arsenic}
          marginBottom={".75rem"}
          marginLeft={"0.5rem"}
        >
          {notificationListData.length ? title : ""}
        </Typography>
        {title === "Today" && notificationListData.length > 0 && (
          <Typography
            variant="h5"
            sx={{
              color: Colors.red,
              marginBottom: "0.75rem",
              cursor: "pointer",
            }}
            onClick={() => handleUnreadBtnClick()}
          >
            View unread
          </Typography>
        )}
      </Box>

      {notificationListData &&
        notificationListData.map((notification, index) => (
          <Box className="notification-panel" key={notification.title}>
            <Box display={"flex"} flexDirection={"column"}>
              <Box display={"flex"} alignItems={"flex-start"}>
                <img
                  src={notification.preIcon}
                  className="notification-icon"
                  alt="notification icon"
                />
                <Box marginLeft={"0.5rem"}>
                  <Box
                    sx={{
                      "& > :not(:first-child)": { marginTop: ".25rem" },
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={500}
                      color={Colors.arsenic}
                    >
                      {notification.title}
                    </Typography>
                    <Typography variant="h6" fontWeight={400} color="#8D8C8E">
                      {notification.description}
                    </Typography>
                  </Box>
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    gap={"0.5rem"}
                    paddingTop={"0.5rem"}
                  >
                    <Typography variant="h6" fontWeight={400} color="#8D8C8E">
                      {title === "Today"
                        ? timeDifferenceInHrs(notification.date, new Date()) +
                          "hrs"
                        : timeDifferenceInDays(notification.date, new Date()) +
                          "d"}
                    </Typography>
                    {notification.isNotificationUnRead && (
                      <CircleRoundedIcon
                        sx={{
                          color: Colors.red,
                          width: ".3331rem",
                          height: ".3331rem",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
              {notification.buttons?.length > 0 && (
                <Box
                  className="btn-group"
                  display="flex"
                  justifyContent={"space-between"}
                  gap="0.5rem"
                  marginTop="0.5rem"
                >
                  <Button
                    variant="contained"
                    className="action-btn"
                    onClick={() => {
                      clevertap.deleteInboxMessage(notification.id);
                      handleNotificationDataChange();
                    }}
                  >
                    {notification.buttons?.[0]?.text}
                  </Button>
                  <Button
                    variant="contained"
                    className="action-btn"
                    onClick={() => {
                      clevertap.markReadInboxMessage(notification.id);
                      handleNotificationDataChange();
                    }}
                  >
                    {notification.buttons?.[1]?.text}
                  </Button>
                </Box>
              )}
            </Box>
            {/* {notification.isNotificationUnRead && (
              <Box onClick={handleNotificationDrawer}>
                <MoreVertRoundedIcon
                  sx={{
                    width: ".875rem",
                    height: ".875rem",
                    color: "#77787B",
                  }}
                />
              </Box>
            )} */}
          </Box>
        ))}
    </Box>
  );
};

export default CommonSearchableScreen;
